<template v-if="!cartStore.loading">
  <div class="o-container a-layout">
    <div class="u-col-span:12 m-checkout__heading">
      <h1 class="m-checkout__title a-h2 u-col-span:12@md">{{ t('cart.general.title') }}</h1>
      <a :href="generateRoute('homepage')" class="m-checkout__back a-btn a-btn--arrow">
        <svg class="a-icon a-icon--back" aria-hidden="true">
          <use href="#chevron-left"></use>
        </svg>
        {{ t('cart.button.continue_shopping') }}
      </a>
    </div>
    <div class="u-col-span:8@md">
      <base-cart />
    </div>
    <div class="u-col-span:4@md m-shipment" v-if="cartStore.cart.products.length > 0">
      <base-shipment-select></base-shipment-select>
    </div>
  </div>
</template>
<script setup lang="ts">
import { onMounted } from 'vue'
import { Product, useCartStore } from '../../stores/cart'
import BaseCart from './BaseCart.vue'
import BaseShipmentSelect from './BaseShipmentSelect.vue'
import { useI18n } from 'vue-i18n'
import { CheckoutStepCart, EventCheckoutStep, emitEvent } from '../../helper/tracking-events'
import { generateRoute } from '../../helper-functions';

const { t } = useI18n()

const cartStore = useCartStore()
onMounted(async () => {
  await cartStore.init()

  emitEvent(EventCheckoutStep, {
    step: CheckoutStepCart,
    products: (cartStore.cart.products ?? []).map((product: Product) => {
      let attributes: { [key: string]: string } = {}
      for (let [key, attributeValue] of Object.entries(product.attributes)) {
        attributes[key] = attributeValue.value
      }

      return {
        ID: product.ID,
        name: product.name,
        configurationOf: product.configuration_of,
        price: product.price,
        qty: product.quantity,
        attributes: attributes,
      }
    }),
  })
})
</script>
